export enum LanguageEnum {
  SPANISH = 0,
  ENGLISH = 1,
  FRENCH = 2,
}